<template>
  <div id="app">
    <router-view />
    <!--浮动框-->
    <div class="tool">
      <div class="relation">
        <div class="weixin-box">
          <svg t="1671590377879"
               class="icon img"
               viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="3983"
               width="128"
               height="128">
            <path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z"
                  fill="#ffffff"
                  p-id="3984"></path>
          </svg>
          <div class="weixin">
            <img src="./assets/topNav/kefu-ercode.png"
                 alt="" />
          </div>
        </div>
<!--        <div class="erweima-box">-->
<!--          <svg t="1671591587100"-->
<!--               class="icon img"-->
<!--               viewBox="0 0 1024 1024"-->
<!--               version="1.1"-->
<!--               xmlns="http://www.w3.org/2000/svg"-->
<!--               p-id="5073"-->
<!--               width="128"-->
<!--               height="128">-->
<!--            <path d="M423.836543 114.819049l0-0.274246L204.08256 114.544803c-45.911656 0-83.09451 36.932144-83.356476 82.59309l-0.023536 0 0 207.579709c0 2.468215 0.500397 4.782933 1.239224 7.000438 6.678096 39.245839 40.831964 69.164243 82.140789 69.164243L423.836543 480.882282l0-0.237407c38.877449-2.432399 70.477144-31.363312 76.798107-68.926836 0.763386-2.217505 1.289366-4.532223 1.289366-7.000438L501.924016 197.137893l-0.025583 0C501.683539 153.253406 467.244168 117.538997 423.836543 114.819049zM458.038506 393.46021c0 24.14798-19.654642 43.705408-43.88551 43.705408L208.445938 437.165618c-24.230867 0-43.858904-19.557428-43.858904-43.705408L164.587034 201.980177c0-24.149003 19.628036-43.717687 43.858904-43.717687l205.708082 0c24.230867 0 43.88551 19.569708 43.88551 43.717687L458.039529 393.46021zM902.246517 195.111746c-0.215918-42.799782-33.818223-77.644381-76.153424-80.304977l0-0.261966L634.384863 114.544803c-44.790112 0-81.040734 36.037774-81.304747 80.56592l-0.023536 0 0 202.511273c0 2.407839 0.476861 4.673439 1.240247 6.831592 6.487761 38.292118 39.830147 67.472717 80.08906 67.472717l191.70823 0 0-0.226151c37.921681-2.385327 68.734454-30.613228 74.961272-67.246567 0.738827-2.158153 1.216711-4.423753 1.216711-6.831592L902.2721 195.111746 902.246517 195.111746zM859.461061 386.638851c0 23.551392-19.152199 42.643216-42.813085 42.643216L638.678656 429.282067c-23.658839 0-42.834574-19.091824-42.834574-42.643216L595.844082 199.832258c0-23.552415 19.175735-42.643216 42.834574-42.643216l177.969321 0c23.660886 0 42.813085 19.091824 42.813085 42.643216L859.461061 386.638851zM415.680792 539.887141l0-0.260943L201.839473 539.626197c-44.670385 0-80.874959 35.94363-81.114412 80.375585l-0.023536 0 0 201.974038c0 2.420119 0.477884 4.687766 1.215688 6.821359 6.464225 38.181601 39.73498 67.316152 79.922261 67.316152L415.680792 896.113331l0-0.236384c37.824467-2.350534 68.567655-30.529317 74.744331-67.079768 0.762363-2.133593 1.24127-4.40124 1.24127-6.821359L491.666394 620.001783l-0.049119 0C491.402381 577.308425 457.919802 542.53648 415.680792 539.887141zM448.975083 811.04077c0 23.493064-19.127639 42.524512-42.691311 42.524512L212.953601 853.565283c0 0-0.022513 0-0.047072 0l-6.822382 0c-23.563672 0-42.690288-19.031449-42.690288-42.524512L163.393859 624.687502c0-23.469528 19.126616-42.525536 42.690288-42.525536l200.200648 0c23.563672 0 42.691311 19.056008 42.691311 42.525536L448.976106 811.04077zM721.154066 753.120616c-14.741749 0-26.66736 11.508102-26.66736 25.699312l0 51.395554c0 14.228049 11.924587 25.721825 26.66736 25.721825 14.736633 0 26.663266-11.492752 26.663266-25.721825l0-51.395554C747.817332 764.628718 735.891721 753.120616 721.154066 753.120616zM834.775846 727.398792c-14.739702 0-26.665313 11.494799-26.665313 25.697265l0 77.118402c0 14.214746 11.924587 25.701358 26.665313 25.701358 14.763239 0 26.688849-11.487635 26.688849-25.701358l0-77.118402C861.464695 738.894613 849.538061 727.398792 834.775846 727.398792zM834.775846 573.172221c-14.739702 0-26.665313 11.506055-26.665313 25.722848l0 51.395554c0 14.189164 11.924587 25.697265 26.665313 25.697265 14.763239 0 26.688849-11.508102 26.688849-25.697265l0-51.395554C861.464695 584.679299 849.538061 573.172221 834.775846 573.172221zM721.154066 573.195757c-14.741749 0-26.66736 11.507078-26.66736 25.709545L694.486706 701.735295c0 14.192234 11.924587 25.686009 26.66736 25.686009 14.736633 0 26.663266-11.492752 26.663266-25.686009L747.817332 598.905302C747.817332 584.702835 735.891721 573.195757 721.154066 573.195757zM606.050538 701.735295c-14.68956 0-26.640754 11.435447-26.640754 25.663496l0 102.81669c0 14.214746 11.951193 25.701358 26.640754 25.701358 14.787798 0 26.712385-11.487635 26.712385-25.701358L632.762923 727.398792C632.763946 713.170742 620.838336 701.735295 606.050538 701.735295zM606.050538 573.172221c-14.68956 0-26.640754 11.506055-26.640754 25.722848l0 25.709545c0 14.201443 11.951193 25.686009 26.640754 25.686009 14.787798 0 26.712385-11.484565 26.712385-25.686009l0-25.709545C632.763946 584.679299 620.838336 573.172221 606.050538 573.172221z"-->
<!--                  fill="#ffffff"-->
<!--                  p-id="5074"></path>-->
<!--          </svg>-->
<!--          <div class="erweima">-->
<!--            <img src="./assets/topNav/6378503774241878654399360.jpg"-->
<!--                 alt="" />-->
<!--          </div>-->
<!--        </div>-->
        <div class="phone-box">
          <div>
            <a href="tel:400-033-0188"
               class="call"><svg t="1671591690877"
                   class="icon img"
                   viewBox="0 0 1024 1024"
                   version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="6051"
                   width="128"
                   height="128">
                <path d="M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7c-20.6 47.8-49.6 90.6-86.4 127.3-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3-18.5 0-35.8 7.2-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-0.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4z m-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 0.9 0.9 21.6-8C570.7 675 674.9 570.8 723.7 438.1l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                      p-id="6052"
                      fill="#ffffff"></path>
              </svg></a>
          </div>
        </div>
        <div class="weixin-box">
          <a @click.prevent="fasong"
             :href="'mailto:'+emailadd">
            <svg t="1682559926255"
                 class="icon img"
                 viewBox="0 0 1024 1024"
                 version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 p-id="3802"
                 width="128"
                 height="128">
              <path d="M886.3 299.8l-381.1 220-371.6-214.6c3.6-56.2 50.3-100.7 107.4-100.7h538.3c55.3 0 100.9 41.6 107 95.3z m0.7 78.8v334.9c0 59.5-48.2 107.7-107.7 107.7H241c-59.5 0-107.7-48.2-107.7-107.7V384.3l354.9 204.9c12.2 7 26.9 5.7 37.5-2.1 0.5-0.2 0.9-0.5 1.4-0.8L887 378.6z"
                    p-id="3803"
                    fill="#ffffff"></path>
            </svg>
          </a>
        </div>
      </div>
      <el-backtop style="right:unset;bottom:unset;background: #ccc;padding: 10px;">
        <svg t="1671594761649"
             class="icon img"
             viewBox="0 0 1040 1024"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             p-id="7260">
          <path d="M29.244045 756.726747c-22.213931 22.217001-22.213931 58.233286 0.002047 80.449263 22.213931 22.215978 58.235332 22.215978 80.447217 0.002047l0.002047-0.002047 0 0 359.679849-359.676779c23.509437-23.511483 61.629639-23.511483 85.142146 0L914.248364 837.231269c22.217001 22.217001 58.234309 22.217001 80.449263 0.002047 22.217001-22.215978 22.217001-58.235332 0-80.45131-0.01842-0.016373-0.035816-0.032746-0.056282-0.053212l-369.178177-369.177154c-62.695924-62.695924-164.348092-62.695924-227.046063 0L29.246091 756.726747l0 0L29.244045 756.726747z"
                fill="#ffffff"
                p-id="7261"></path>
          <path d="M967.066313 169.870876l-0.002047 0 0-0.002047L56.880475 169.868829l0 0.002047c-31.417547 0.002047-56.880475 25.469068-56.880475 56.886615 0 31.413454 25.462928 56.883545 56.880475 56.885592l0 0 910.184815 0 0 0 0.002047 0c31.4155 0 56.883545-25.470091 56.883545-56.885592C1023.949858 195.337897 998.482837 169.870876 967.066313 169.870876z"
                fill="#ffffff"
                p-id="7262"></path>
        </svg>
      </el-backtop>
    </div>
  </div>

  <!-- </div> -->

</template>
<script>
import axios from 'axios';

export default {
  name: "App",
  data () {
    return {
      companyInfoList: {},
      emailadd: 'bbjt69@bbjt88.com'
    };
  },
  components: {},
  created () {
    this.companyInfoList = JSON.parse(localStorage.getItem("companyInfo"))
    console.log(this.companyInfoList);
    console.log(document.location)
    if ((navigator.userAgent.indexOf('MicroMessenger') !== -1 || navigator.userAgent.indexOf('Weixin') !== -1 || navigator.userAgent.indexOf('wechat') !== -1)) {
      if (document.location.href.indexOf('code') !== -1) {
        console.log('getCode')
        var code = document.location.href.split('?')[1].split('&')[0].split('=')[1]
        this.getOpenid(code)
      } else {
        // document.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa6e704a6b5babe44&redirect_uri=${document.location.href}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
        // document.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa6e704a6b5babe44&redirect_uri=${document.location.href}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      }
    }
  },
  mounted () {
    console.log(this.isMobile())
    axios.get('https://api.it120.cc/gooking/forex/rate?fromCode=USD&toCode=CNY').then(res => {
      console.log(res)
      localStorage.setItem('rate', res.data.data.rate)
    })
  },
  methods: {
    fasong () {
      var la = localStorage.getItem('lang')
      if (la) {
        //369104673@qq.com德语法语。  369104673@qq.com俄语。369104673@qq.com西班牙 阿拉伯。369104673@qq.com英语。369104673@qq.com中文。  每个语言网站相应的邮箱
        if (la === 'de' || la === 'fr') {
          this.emailadd = '369104673@qq.com'
        } else if (la === 'ru' || la === 'be') {
          this.emailadd = '369104673@qq.com'
        } else if (la === 'es' || la === 'ar') {
          this.emailadd = '369104673@qq.com'
        } else if (la === 'en') {
          this.emailadd = '369104673@qq.com'
        } else {
          this.emailadd = '369104673@qq.com'
        }
      }
      window.open('mailto:' + this.emailadd, 'mail')
    },
    async getOpenid (code) {
      let res = await this.api.post(this.apiPath.queryPayState1, { order_no: code });
      console.log(res)
      localStorage.setItem('openid', res.openid)
      return res
    }
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
}
.el-backtop {
  // width: 50px !important;
  // height: 50px !important;
  // margin: 10px;
  border-radius: 0 !important;
  position: relative !important;
  width: unset !important;
  height: unset !important;
  // right: 18px !important;
  // bottom: 0% !important;
  // border-radius: 0 !important;
}
.tool {
  position: fixed;
  z-index: 999;
  top: 68%;
  right: 20px;
}
.relation {
  svg {
    width: 50px;
    height: 50px;
  }
  .img {
    width: 35px;
    height: 35px;
    margin: 10px;
  }
  div {
    cursor: pointer;
  }
  .erweima-box {
    position: relative;
    background: #ccc;
    border-bottom: 1px solid #fff;
    .erweima {
      position: absolute;
      top: -50px;
      left: -120px;
      display: none;
    }
  }
  .erweima-box:hover .erweima {
    display: block;
  }
  .weixin-box {
    background-color: #ccc;
    position: relative;
    border-bottom: 1px solid #fff;
    .weixin {
      width: 110px;
      height: 110px;
      position: absolute;
      top: -30px;
      left: -120px;
      display: none;
    }
  }
  .weixin-box:hover .weixin {
    display: block;
  }
  .phone-box {
    background: #ccc;
    border-bottom: 1px solid #fff;
  }
  .phone-box:hover .phone {
    display: block;
  }
}

@media screen and (max-width: 750px) {
  .relation .img {
    width: 30px;
    height: 30px;
    line-height: 0;
    margin: 0;
  }
  .relation .phone-box {
    padding: 4px;
    // height: 40px;
    // width: 40px;
    // text-align: center;
    // line-height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .erweima-box {
    display: none;
  }
  .weixin-box {
    text-align: center;
    padding: 4px;
    // display: none;
  }
  .main .product {
    padding-top: 1px !important;
  }
}
</style>
<style>
@media screen and (max-width: 750px) {
  .el-backtop {
    height: 40px;
    width: 40px;
    padding: 4px;
    /* bottom: 100px !important;
    right: 10px !important;
    width: 30px !important;
    height: 30px !important; */
  }
  #nb_icon_wrap {
    width: 45px !important;
    height: 45px !important;
  }
  #newBridge .nb-icon-wrap {
    top: 66% !important;
  }
  .tool {
    right: 6px;
  }
}
</style>
